import {environment} from './environment';
const env = environment;
const CURRENT_CONFIG = require(`./config/config.${env}.js`);
export default CURRENT_CONFIG.default;
